import {
  hydrateItemsFromExternalId,
  hydrateItemsFromTargets,
  hydrateXForYValues,
  normalizeDiscountValues,
  syncDiscountScope
} from '@/components/rewards/utils/offerRewardHydration'
import { slugBelongsTo } from '@/components/rewards/utils/rewardTypeRegistry'
import { getCartMinimumAmountEuros, setCartMinimumAmountEuros } from '@/components/rewards/utils/rewardAccessConditions'

import type { LoyaltyReward } from '@/types/types'
import type { ApplyReductionOn } from '@/types/offer'

export function getApplyReductionOn(reward: LoyaltyReward | null | undefined): ApplyReductionOn {
  if (!reward) return 'cart'
  if (reward.applyReductionOn) return reward.applyReductionOn
  return reward.items?.length ? 'products' : 'cart'
}

export function initializeRewardForm(reward: LoyaltyReward, rewardTypeIdsBySlug: Record<string, number> | null): void {
  reward.includedSegmentIds ||= []
  reward.excludedSegmentIds ||= []

  hydrateItemsFromExternalId(reward)
  syncDiscountScope(reward, rewardTypeIdsBySlug)
  hydrateItemsFromTargets(reward)

  const conditions = reward.conditions ?? []

  if (slugBelongsTo('xForY', reward.rewardType?.slug)) {
    hydrateXForYValues(reward, conditions)
  } else {
    normalizeDiscountValues(reward)
  }

  if (slugBelongsTo('freeDelivery', reward.rewardType?.slug)) {
    const fromConditions = getCartMinimumAmountEuros(reward)
    if (fromConditions == null && reward.minimumOrderAmount != null && reward.minimumOrderAmount > 0) {
      setCartMinimumAmountEuros(reward, reward.minimumOrderAmount)
      reward.minimumOrderAmount = null
    }
  }
}

export function resetRewardFieldsOnTypeChange(reward: LoyaltyReward): void {
  reward.value = null
  reward.voucherDiscountAmount = null
  reward.discountValuePercent = null
  reward.minimumOrderAmount = null
  reward.applyReductionOn = 'cart'
  reward.items = []
  reward.accessCondition = 'none'
  reward.cartItemCount = null
  reward.requiredProductExternalIds = []
  reward.conditions = (reward.conditions ?? []).filter((condition) => condition.type !== 'required_products')
}
